import styled from "styled-components";

export const StyledCard = styled.div`
  background: ${({ theme }) => theme.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
`;
